export const toDecimalString = (value, decimalDigits) => {
    let res;
    if(!value) {
        res = "0.-";
    } else {
        if(!decimalDigits) {
            res = String(value);
        } else {
            if(value % 1 === 0) {
                res = Math.trunc(value) + ".-";
            } else {
                res = value.toFixed(decimalDigits);
            }
        }
    }
    return res;
};

export const toTimeString = (value) => {
    if (!value) {
        return;
    }

    let result;
    const hours = Math.floor(value / 60);
    const minutes = value % 60;

    if (hours < 1) {
        result = minutes + "min";
    } else {
        result = hours + "h";
        if (minutes > 0) {
            result += " " + minutes + "min";
        }
    }

    return result;
};

export const pad = (d) => {
    return (d < 10) ? "0" + d.toString() : d.toString();
};
